import * as loadImage from 'blueimp-load-image';
import { IMAGE_MAX_SIZE, IMAGE_QUALITY, IMAGE_STANDARD_QUALITY, IMAGE_STANDARD_SIZE } from '../../config';
// import FileSaver, { saveAs } from 'file-saver';

const imageLoading = async (img, maxSize = false) => {
  const imageBaseURI = new Promise((resolve) => {
    loadImage(
      img,
      (fileOrBlobImg) => {
        resolve(fileOrBlobImg.toDataURL('image/jpeg', maxSize ? IMAGE_QUALITY : IMAGE_STANDARD_QUALITY));
      },
      {
        maxWidth: maxSize ? IMAGE_MAX_SIZE : IMAGE_STANDARD_SIZE,
        maxHeight: maxSize ? IMAGE_MAX_SIZE : IMAGE_STANDARD_SIZE,
        canvas: true,
        orientation: true,
      },
    );
  });
  return imageBaseURI;
};
export default imageLoading;
